import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ShorthandTimePicker from '../../components/ShorthandTimePicker.tsx';

interface DashboardHeaderProps {
  title: string;
  rangeMinutes: number;
  dateFromValue: Dayjs | null;
  dateToValue: Dayjs | null;
  setDateFromValue: Dayjs | null;
  setDateToValue: Dayjs | null;
  setRangeMinutes: number;
};


export default function DashboardHeader({
   title,
   rangeMinutes,
   setRangeMinutes,
   dateFromValue,
   dateToValue,
   setDateFromValue,
   setDateToValue }: DashboardHeaderProps) {
  return (
  <>
    <header className='sensor-dashboard-header'>
      <h2>{title}</h2>
    </header>
    <header>
      <div data-testid='time-range-picker-div' className='time-range-picker-div'>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ShorthandTimePicker
          rangeMinutes={rangeMinutes}
          setRangeMinutes={setRangeMinutes}
         />
        <MobileDateTimePicker
          label="Date From"
          value={dateFromValue}
          onChange={setDateFromValue}
        />
        <MobileDateTimePicker
          label="Date To"
          value={dateToValue}
          onChange={setDateToValue}
        />
        </LocalizationProvider>
      </div>
    </header>
  </>
  )
}
